import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import FomcCalendar from '../shared/FomcCalendar';
import { getTab } from '../config';

/**
 * Federal funds rate and monetary policy.
 *
 * Adds the FOMC meeting schedule to the shared factor layout. The schedule is
 * fetched from the Fed's published calendar rather than written in here, which
 * is what let the previous version keep advertising a 2025 meeting as "next".
 */
const FedFundsTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('fedfunds')} data={data} period={period}>
    <FomcCalendar />
  </FactorTabLayout>
);

export default FedFundsTab;
